<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body two-columns form-wrapper">
      <div id="info" class="left">
        <div class="block">
          <h3>{{ $t('product_form') }}</h3>
          <ProductForm :product="product" @save-product="handleSaveProduct" :loading="loading"></ProductForm>
        </div>

        <div class="block margin-top-20">
          <h3>{{ $t('pricing_form') }}</h3>
          <PricingForm :product="product" @save-product="handleSaveProduct" :loading="loading"></PricingForm>
        </div>
      </div>
      <div class="right">
        <div class="block">
          <h3>{{ $t('thumb') }}</h3>
          <Uploader v-if="productId" @on-success="handleFileUploaded" :defaultFileList="thumbData" :model-id="productId" :model-type="modelType" :max-num="1" accept=".jpg, .jpeg, .png, .gif, .svg, .bmp" drag-drop></Uploader>
        </div>

        <div class="block margin-top-20" v-if="product && product.product_type !== 'service'">
          <h3>{{ $t('technical_data') }}</h3>
          <ProductManufacturerPartPlugin v-if="product" :product="product"></ProductManufacturerPartPlugin>
        </div>

        <div class="block margin-top-20">
          <h3>{{ $t('product.tabs.attachments') }}</h3>
          {{ $t('product.attachments.description') }}
          <ProductAttachmentsPlugin v-if="productId" :product-id="productId"></ProductAttachmentsPlugin>
        </div>

        <div class="block margin-top-20">
          <h3>{{ $t('product.tabs.quotes') }}</h3>
          <ProductQuotesPlugin v-if="product" :product="product"></ProductQuotesPlugin>
        </div>

        <div class="block margin-top-20">
          <h3>{{ $t('product.tabs.orders') }}</h3>
          <ProductOrdersPlugin v-if="product" :product="product"></ProductOrdersPlugin>
        </div>

        <div class="block margin-top-20">
          <h3>{{ $t('product.tabs.projects') }}</h3>
          Not yet implemented
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { uploadThumbnail } from '@/api/file'
import ProductForm from './forms/product-form'
import PricingForm from './forms/pricing-form'
import Uploader from '@/components/images/uploader'
import {
  ProductAttachmentsPlugin,
  ProductBomPlugin,
  ProductQuotesPlugin,
  ProductOrdersPlugin,
  ProductManufacturerPartPlugin } from './plugins'

export default {
  name: 'EditProduct',
  components: {
    ProductForm,
    PricingForm,
    Uploader,
    ProductAttachmentsPlugin,
    ProductBomPlugin,
    ProductQuotesPlugin,
    ProductOrdersPlugin,
    ProductManufacturerPartPlugin
  },
  data () {
    return {
      productId: this.$route.params.productId,
      loading: false,
      thumbData: [],
      modelType: 'product'
    }
  },
  mounted () {
    this.loadProductInfo()
  },
  computed: {
    ...mapGetters(['product']),
    pageTitle () {
      document.title = this.$t('menu.product.edit_product') + ' - ' + this.product?.product_name
      return document.title
    }
  },
  methods: {
    ...mapActions([
      'getProduct',
      'updateProduct'
    ]),
    loadProductInfo () {
      this.loading = true
      this.getProduct(this.productId)
        .then(resp => {
          this.thumbData = resp.thumb
        })
        .finally(() => {
          this.loading = false
        })
    },
    addABom () {
      this.$router.push({
        name: 'menu.bom.bom_tool',
        query: {
          productId: _.toNumber(this.$route.params.productId)
        }
      })
    },
    handleSaveProduct (data) {
      this.updateProduct(data).then(res => {
        this.$Message.success('Successfully saved!')
      })
    },
    handleFileUploaded (fileManaged) {
      uploadThumbnail(this.modelType, this.productId, fileManaged.id).then(resp => {
        this.$Message.success('Upload successfully!')
      })
    }
  }
}
</script>
